import React, { useState, useEffect } from "react";

import "./selectDishForm.css";

const SelectDishForm = ({
  menu,
  dishes,
  isDishesLoading,
  dishProp,
  dishPropIndex,
  dishPropRemoveId,
  handleAddDishToMenuAndClose,
  handleCloseSelectDishForm
}) => {
  const [currentDishBody, setCurrentDishBody] = useState(
    dishProp && dishProp.dishBody ? { ...dishProp.dishBody } : {}
  );
  const [currentDish, setCurrentDish] = useState(
    dishProp ? { ...dishProp } : { quantity: 10 }
  );

  const [selectDishOptions, setSelectDishOptions] = useState([...dishes]);

  const [filter, setFilter] = useState({});

  const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);
  const [subcategoryFilterOptions, setSubcategoryFilterOptions] = useState([]);
  const [
    subcategoriesWithinCategories,
    setSubcategoriesWithinCategories
  ] = useState([]);

  const handleSelectDishBodyChange = (e) => {
    let workingObject = {};
    let selectedDish = JSON.parse(e.target.value);

    workingObject = { ...selectedDish };

    setCurrentDishBody({ ...workingObject });
  };

  const handleDishChange = (e) => {
    let workingObject = {};

    if (!e.target.value) {
      workingObject.quantity = 100;
    } else {
      workingObject.quantity = e.target.value;
    }

    setCurrentDish({ ...currentDish, ...workingObject });
  };

  // handle filters and selectDishOptions
  const handleSearchFilterChange = (e) => {
    const workingObject = {};
    workingObject.searchTerm = e.target.value;
    setFilter({ ...filter, ...workingObject });
  };

  const handleCategoryFilterChange = (e) => {
    const workingObject = {};
    workingObject.category = e.target.value;
    setFilter({ ...filter, ...workingObject });
  };

  const handleSubcategoryFilterChange = (e) => {
    const workingObject = {};
    workingObject.subcategory = e.target.value;
    setFilter({ ...filter, ...workingObject });
  };

  // change filters based on each other
  // initial unique categories and subcategories
  useEffect(() => {
    let categoriesArray = dishes.map((dish) => dish.category);

    let subcategoriesArray = dishes.map((dish) => dish.subcategory);
    subcategoriesArray = subcategoriesArray.filter(
      (subcategory) => subcategory !== ""
    );

    //let subcategoriesWithinCategoriesArray = [];

    let uniqueCategories = categoriesArray.reduce(
      (acc, x) => acc.concat(acc.find((y) => y === x) ? [] : [x]),
      []
    );
    let uniqueSubcategories = subcategoriesArray.reduce(
      (acc, x) => acc.concat(acc.find((y) => y === x) ? [] : [x]),
      []
    );

    let subcategoriesWithinCategoriesArray = uniqueCategories.map(
      (category) => {
        let workingArray = [];
        let categoryObject = {
          category: category
        };
        categoryObject.subcategories = [];

        let dishesWithCategory = dishes.filter(
          (dish) => dish.category === category
        );

        dishesWithCategory.forEach((dish) =>
          workingArray.push(dish.subcategory)
        );

        workingArray = workingArray.filter((subcategory) => subcategory !== "");

        let uniqueWorkingArray = workingArray.reduce(
          (acc, x) => acc.concat(acc.find((y) => y === x) ? [] : [x]),
          []
        );

        uniqueWorkingArray.forEach((subcategory) =>
          categoryObject.subcategories.push(subcategory)
        );

        return categoryObject;
      }
    );

    setCategoryFilterOptions([...uniqueCategories]);
    setSubcategoryFilterOptions([...uniqueSubcategories]);
    setSubcategoriesWithinCategories([...subcategoriesWithinCategoriesArray]);
  }, []);

  // subcategory
  useEffect(() => {
    if (filter.category) {
      const workingObject = {};
      let subcategoryFilterOptionsArray = subcategoriesWithinCategories.filter(
        (item) => item.category === filter.category
      );

      setSubcategoryFilterOptions([
        ...subcategoryFilterOptionsArray[0].subcategories
      ]);

      // workingObject.subcategory = subcategoryFilterOptionsArray[0].subcategories[0];
      workingObject.subcategory = "";

      setFilter({ ...filter, ...workingObject });
    }
  }, [filter.category]);

  // change selectDishOptions based on filters
  useEffect(() => {
    let workingArray = [...dishes];

    if (filter.category) {
      workingArray = workingArray.filter(
        (dish) => dish.category === filter.category
      );
    }

    if (filter.subcategory) {
      workingArray = workingArray.filter(
        (dish) => dish.subcategory === filter.subcategory
      );
    }

    if (filter.searchTerm) {
      let term = filter.searchTerm.toLowerCase();
      workingArray = workingArray.filter((dish) =>
        dish.name.toLowerCase().includes(term)
      );
    }

    setSelectDishOptions([...workingArray]);
  }, [filter]);

  // change currentDish
  useEffect(() => {
    const workingObject = {};

    workingObject.dishBody = { ...currentDishBody };

    setCurrentDish({ ...currentDish, ...workingObject });
  }, [currentDishBody]);

  return (
    <div className="selectDishForm__containerDiv">
      <div className="containerDiv__currentDishDiv">
        {currentDishBody.name
          ? `selected item: \n${currentDishBody.name}`
          : "select an item from the list"}
      </div>
      <div className="containerDiv__formArea">
        <div className="formArea__dishSelect">
          {isDishesLoading ? <div>Items loading...</div> : null}
          <select
            name=""
            id=""
            size="5"
            value={JSON.stringify(currentDishBody)}
            onChange={handleSelectDishBodyChange}
          >
            <option value="" hidden>
              Select item
            </option>
            {selectDishOptions.length &&
              selectDishOptions.map((dish) => (
                <option key={dish._id} value={JSON.stringify(dish)}>
                  {dish.name}
                </option>
              ))}
          </select>
        </div>
        <div className="formArea__searchFilterInput">
          <input
            type="text"
            placeholder="Enter item name..."
            value={filter.searchTerm ? filter.searchTerm : ""}
            onChange={handleSearchFilterChange}
          />
        </div>
        <div className="formArea__categoryFilterSelect">
          <select
            name=""
            id=""
            value={filter.category}
            onChange={handleCategoryFilterChange}
          >
            <option value="">Category</option>
            {categoryFilterOptions &&
              categoryFilterOptions.map((category) => (
                <option value={category} key={category}>
                  {category}
                </option>
              ))}
          </select>
        </div>
        <div className="formArea__subcategoryFilterSelect">
          <select
            name=""
            id=""
            value={filter.subcategory}
            onChange={handleSubcategoryFilterChange}
          >
            <option value="">Subcategory</option>
            {subcategoryFilterOptions &&
              subcategoryFilterOptions.map((subcategory) => (
                <option value={subcategory} key={subcategory}>
                  {subcategory}
                </option>
              ))}
          </select>
        </div>
        {menu.purposeType === "website" && menu.websitePurpose !== "static" ? (
          <div className="formArea__quantityInput">
            <div>in stock</div>
            <input
              type="number"
              name="quantity"
              id="quantity"
              min="0"
              value={currentDish.quantity}
              onChange={handleDishChange}
            />
          </div>
        ) : null}
      </div>
      <div className="containerDiv__controlsArea">
        <button
          className="controlsArea__saveDishBtn"
          onClick={
            !dishProp
              ? () => {
                  if (
                    menu.dishes.findIndex(
                      (dish) => dish.dishBody.name === currentDish.dishBody.name
                    ) === -1
                  ) {
                    handleAddDishToMenuAndClose(currentDish);
                  } else {
                    alert(`${currentDish.dishBody.name} is already in menu!`);
                  }
                }
              : () => {
                  if (
                    menu.dishes.findIndex(
                      (dish) => dish.dishBody.name === currentDish.dishBody.name
                    ) === -1
                  ) {
                    handleAddDishToMenuAndClose(
                      currentDish,
                      dishPropIndex,
                      dishPropRemoveId
                    );
                  } else {
                    alert(`${currentDish.dishBody.name} is already in menu!`);
                  }
                }
          }
        >
          save item
        </button>
        <button
          className="controlsArea__cancelDishBtn"
          onClick={() => handleCloseSelectDishForm()}
        >
          back
        </button>
      </div>
    </div>
  );
};

export default SelectDishForm;
